import script from "./MobileReceivedReportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReceivedReportPage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=6bac1ad7&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bac1ad7"]])

export default __exports__